export const ACCESSORIAL_FIELDS = [
  {
    key: "liftgate_delivery",
    label: "Liftgate",
    yes: "Required",
    no: "Not required",
  },
  {
    key: "residential_delivery",
    label: "Delivery site",
    yes: "Residential",
    no: "Commercial",
  },
  {
    key: "limited_access_delivery",
    label: "Limited access",
    yes: "Required",
    no: "Not required",
  },
  {
    key: "inside_delivery",
    label: "Inside delivery",
    yes: "Required",
    no: "Not required",
  },
  {
    key: "appointment_delivery",
    label: "Appointment",
    yes: "Required",
    no: "Not required",
  },
  {
    key: "construction_site_delivery",
    label: "Construction site",
    yes: "Required",
    no: "Not required",
  },
] as const;

export type AccessorialKey = (typeof ACCESSORIAL_FIELDS)[number]["key"];
export type Accessorials = Record<AccessorialKey, boolean | null>;

export function readAccessorials(
  snapshot: Record<string, unknown>,
): Accessorials {
  const values = {} as Accessorials;
  for (const { key } of ACCESSORIAL_FIELDS) {
    const raw = snapshot[key];
    const value =
      raw && typeof raw === "object" && "value" in raw ? raw.value : raw;
    values[key] = typeof value === "boolean" ? value : null;
  }
  return values;
}

/** One line for the details grid: the required extras, then the site when residential. */
export function accessorialSummary(values: Accessorials): string {
  if (ACCESSORIAL_FIELDS.every(({ key }) => values[key] === null))
    return "Not set";
  const required: string[] = ACCESSORIAL_FIELDS.filter(
    ({ key }) => key !== "residential_delivery" && values[key] === true,
  ).map(({ label }) => label);
  if (values.residential_delivery === true) required.push("Residential");
  return required.join(", ") || "None";
}
